import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css'],
})
export class ServicesComponent implements OnDestroy {
  @Input() validationToken = '';
  @Output() saved = new EventEmitter<void>();

  files: File[] = [];
  loading = false;
  errorMessage = '';

  private readonly maxFiles = 2;
  private readonly maxSizeMB = 10;
  private readonly allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    this.errorMessage = '';

    for (let i = 0; i < input.files.length; i++) {
      const file = input.files[i];

      if (this.files.length >= this.maxFiles) {
        this.errorMessage = `Puede subir un máximo de ${this.maxFiles} archivos.`;
        break;
      }

      if (!this.allowedTypes.includes(file.type)) {
        this.errorMessage = `El archivo "${file.name}" no es un formato válido. Use PDF, JPG, PNG o WebP.`;
        continue;
      }

      if (file.size > this.maxSizeMB * 1024 * 1024) {
        this.errorMessage = `El archivo "${file.name}" supera los ${this.maxSizeMB}MB permitidos.`;
        continue;
      }

      this.files.push(file);
    }

    input.value = '';
  }

  removeFile(index: number): void {
    this.files.splice(index, 1);
    this.errorMessage = '';
  }

  onSubmit(): void {
    if (this.files.length === 0) {
      this.errorMessage = 'Debe subir al menos un comprobante de servicio.';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    this.onboardingService
      .uploadServices(this.files, this.validationToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading = false;
          this.saved.emit();
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al subir los comprobantes. Intentá nuevamente.';
          }
        },
      });
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }
}
